module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-parallax-section"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.05),
      expression: "0.05"
    }],
    staticClass: "block-parallax-section__parallax"
  }, [_vm._t("image", null, {
    "content": _vm.props.image
  })], 2), _c('div', {
    staticClass: "block-parallax-section__textbox"
  }, [_vm._t("header", null, {
    "content": _vm.props.header
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2809b49d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-parallax-section/block-parallax-section.pug
// module id = 581
// module chunks = 1